import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Form } from 'antd';
import { LinkInput } from './LinkInput';
import React from 'react';
import { SonarModal } from './modals';
export class LinkModal extends React.Component {
    constructor() {
        super(...arguments);
        this.linkFormRef = React.createRef();
        this.handleOnOkClick = () => {
            const { onOk } = this.props;
            const { current } = this.linkFormRef;
            current === null || current === void 0 ? void 0 : current.validateFields().then((values) => {
                if (!values.title) {
                    values.title = values.url;
                }
                onOk(values);
                current.resetFields();
            }).catch((info) => {
                throw new Error(info);
            });
        };
        this.handleOnCancelClick = () => {
            const { onCancel } = this.props;
            const { current } = this.linkFormRef;
            current === null || current === void 0 ? void 0 : current.resetFields();
            onCancel();
        };
        this.getInitialFieldValues = (link) => {
            const { current } = this.linkFormRef;
            const title = (current === null || current === void 0 ? void 0 : current.getFieldValue('title')) || (link === null || link === void 0 ? void 0 : link.title);
            const url = (current === null || current === void 0 ? void 0 : current.getFieldValue('url')) || (link === null || link === void 0 ? void 0 : link.url);
            return [
                {
                    name: 'title',
                    value: title
                },
                {
                    name: 'url',
                    value: url
                }
            ];
        };
    }
    render() {
        const { disabled, open, link } = this.props;
        return (React.createElement(SonarModal, { className: 'link-modal', okText: link ? COPY_SPECIFIC.UPDATE : COPY_SPECIFIC.SAVE, onCancel: this.handleOnCancelClick, onOk: this.handleOnOkClick, open: open, title: link ? COPY_SPECIFIC.UPDATE_LINK : COPY_SPECIFIC.ADD_A_LINK },
            React.createElement(Form, { fields: this.getInitialFieldValues(link), ref: this.linkFormRef },
                React.createElement(LinkInput, { disabled: disabled }))));
    }
}
